<div class="add-70">
    <div class="full-banner">
        <div class="container align-items-center flex-wrap h-100" style="display: grid;">
            <div>
                <h2 class="font-600 text-center mb-5">
                    Customize your Journey!
                    <br>
                    Choose or Explore more Possibilities
                </h2>
                <div class="text-center h-10">
                    <button class="btn button brand-button" type="button" style="width: 20vmax;" (click)="scroll(target)">Let's Explore</button>
                </div>
            </div>
        </div>
        <div class="down-arrow">
            <img src="assets/img/drop_down.svg" alt="">
        </div>
    </div>
</div>

<div class="page-section" #target>
    <div class="container">
        <div class="row" *ngIf="stored_choices && stored_choices.selected_setup">
            <div class="col text-center">
                <h3>Our Recommendations</h3>
            </div>
        </div>
        <div class="row" *ngIf="stored_choices && stored_choices.selected_setup">
            <div class="col">
                You selected: 
                <span class="clicked-slug">{{stored_choices.selected_setup.label}}</span>
                <span class="clicked-slug" *ngIf="stored_choices.selected_bed">{{stored_choices.selected_bed.label}}</span>
                <ng-contianer *ngFor="let dept of _selected_departments">
                    <span class="clicked-slug">{{dept}}</span>
                </ng-contianer>
            </div>
        </div>
        <div class="row mt-3">
            <ng-container *ngFor="let card of selected_cards">
                <ng-container>
                    <div class="col-lg-3 col-md-6 col-12 smooth">
                        <div class="card border-mint product-card">
                            <div class="card-body text-center">
                                <div class="card-top">
                                    <img [src]="card.link" [alt]="card.name">
                                    <div class="card-name">
                                        <h5>{{card.name}}</h5>
                                    </div>
                                </div>
                                <div class="card-bottom">
                                    <ng-container *ngFor="let desc of card.description; let i = index">
                                        <span class="card-description">{{desc}}</span>
                                        <ng-container *ngIf="i < card.description.length - 1">
                                            •
                                        </ng-container>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </div>

        <div class="row">
            <div class="col text-center">
                <h3>Our <span *ngIf="stored_choices && stored_choices.selected_setup">Other</span> Offerings</h3>
            </div>
        </div>
        <div class="row mt-3">
            <ng-container *ngFor="let card of product_cards">
                <ng-container *ngIf="!card.already_selected">
                    <div class="col-lg-3 col-md-6 col-12 smooth" (click)="selectCard(card)">
                        <div class="select-marker smooth">
                            <img src="assets/img/circle.svg" alt="circle" *ngIf="!card.is_selected">
                            <img src="assets/img/circle-select.svg" alt="circle" *ngIf="card.is_selected">
                        </div>
                        <div class="card product-card smooth" [ngClass]="card.is_selected == 1 ? 'border-mint' : 'border-black'">
                            <div class="card-body text-center">
                                <div class="card-top">
                                    <img [src]="card.link" [alt]="card.name">
                                    <div class="card-name">
                                        <h5>{{card.name}}</h5>
                                    </div>
                                </div>
                                <div class="card-bottom">
                                    <ng-container *ngFor="let desc of card.description; let i = index">
                                        <span class="card-description">{{desc}}</span>
                                        <ng-container *ngIf="i < card.description.length - 1">
                                            •
                                        </ng-container>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </div>
</div>

<app-send-info-banner></app-send-info-banner>
<app-send-updates></app-send-updates>